import React from 'react'
import List from '../components/List'
import hipladeTemplate from '../../common/template'

function RoomsList() {
  return <List />
}

export default hipladeTemplate(RoomsList)
